export default __webpack_public_path__ + "static/media/inflammation.e24d52f8.jpg";